/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MediaDto } from '../../models/media-dto';

export interface UploadProductReviewMedia$Params {
      body: {

/**
 * Image file. Allowed formats: jpg, jpeg, png, webp, svg, tiff, gif
 */
'file': Blob;
}
}

export function uploadProductReviewMedia(http: HttpClient, rootUrl: string, params: UploadProductReviewMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<MediaDto>> {
  const rb = new RequestBuilder(rootUrl, uploadProductReviewMedia.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MediaDto>;
    })
  );
}

uploadProductReviewMedia.PATH = '/api/v1/product-reviews/media';
